var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.959 9.638c-1.154-.403-2.044-.771-2.163-1.214-.11-.417.176-.667.582-1.234.264-.357.487-.766.661-1.205a5.826 5.826 0 0 0 .405-2.102c0-.086-.003-.17-.007-.253-.053-1.117-.461-2.027-1.088-2.656A3.268 3.268 0 0 0 8.167.21a3.429 3.429 0 0 0-1.183-.21L6.97 0C5.052 0 3.496 1.512 3.496 3.883c0 1.175.382 2.34 1 3.216l.003.005c.438.63.759.882.642 1.32-.119.446-1.02.816-2.186 1.222a1.538 1.538 0 0 0-.032.012C1.776 10.052 0 10.955 0 12.495v.691h13.94v-.69c0-1.567-1.844-2.475-2.981-2.858Z",
    fill: "#2E3586"
  })));
};
export default SvgIconUser;